import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapTableInitiativePlanningIndexRoute extends Route {
  @service router;

  beforeModel() {
    this.router.transitionTo('backlog.initiatives.initiative.planning.weeks');
  }
}

export default instrumentRoutePerformance(
  RoadmapTableInitiativePlanningIndexRoute,
);
